import { render, staticRenderFns } from "./source-button.vue?vue&type=template&id=7537f528&scoped=true&"
import script from "./source-button.vue?vue&type=script&lang=ts&"
export * from "./source-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537f528",
  null
  
)

export default component.exports